import { createSlice } from '@reduxjs/toolkit';
import { fetchNetworks, selectNetwork } from '../networks/networksSlice';

const initialState = {
  amount: 0,
  sku: null,
  availableAmounts: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setAmount(state, action) {
      state.amount = action.payload;
    },

    setSku(state, action) {
      state.sku = action.payload;
    },
  },
  extraReducers: {
    [fetchNetworks.fulfilled]: (state, action) => {
      state.availableAmounts = action.payload.reduce((acc, curr) => {
        acc[curr.name] = {
          2: curr.dataPackets.map((obj) => obj.amount),
          1: curr.topUpPackets.map((obj) => obj.amount),
        };

        return acc;
      }, {});
    },

    [selectNetwork]: (state, action) => {
      state.amount = 0;
      state.sku = null;
    },
  },
});

export const { setAmount, setSku } = productSlice.actions;

export default productSlice.reducer;
